import React from 'react';

interface IconProps {
  icon: React.ReactElement;
  className?: string;
  noFill?: boolean;
  noStroke?: boolean;
}

const Icon: React.FC<IconProps> = ({
  icon,
  className = '',
  noFill = false,
  noStroke = false
}) => {
  const classes = [
    'icon',
    noFill && 'icon--no-fill',
    noStroke && 'icon--no-stroke',
    className
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classes}>
      {icon}
    </span>
  );
};

export default Icon; 